import Http from '@/assets/ts/classes/Http'

const useWorkoutWeek = () => {

  /**
   * POST request to reset the current week by resetting all
   * Sessions for the Member that have the current Week Number.
   *
   * @param id The member ID.
   */
  const resetWeek = async ( id: number ) => Http.post( `/member/${id}/workout-week`, { reset: true } )

  /**
   * POST request to handle switching a phase in a Program.
   *
   * @param id The member ID.
   * @param phase An object containing the new week number and if it's a previous phase.
   */
  const switchPhase = async ( id: number, phase: Record<string, unknown> ) =>
    Http.post( `/member/${id}/workout-week`, { switchPhase: true, ...phase } )

  /**
   * POST request to handle skipping a week, which increments
   * the week on the server (ex: Week 1 > Week 2).
   *
   * @param id The member ID.
   */
  const skipWeek = async ( id: number ) =>
    Http.post( `/member/${id}/workout-week`, { skip: true } )

  /**
   * POST request to handle skipping a workout in the current week.
   *
   * @param id The member ID.
   * @param workoutId The workout ID to skip.
   */
  const skipWorkout = async ( id: number, workoutId: number ) =>
    Http.post( `/member/${id}/workout-week`, { skipWorkout: true, workoutId } )

  /**
   * POST request to handle resetting a completed workout.
   *
   * @param id The member ID.
   * @param sessionId The session ID to reset.
   */
  const resetWorkout = async ( id: number, sessionId: number ) =>
    Http.post( `/member/${id}/workout-week`, { resetWorkout: true, sessionId } )

  /**
   * Get the landscape for the workout week.
   *
   * @param id The member ID.
   * @returns The workout week.
   */
  const getWorkoutWeek = async ( id: number ) => Http.get( `/member/${id}/workout-week` )

  return {
    resetWeek,
    skipWeek,
    skipWorkout,
    resetWorkout,
    switchPhase,
    getWorkoutWeek
  }

}

export default useWorkoutWeek
